import { createSlice } from "@reduxjs/toolkit";

import type { CreditCard } from "@app/types/napi-types";

import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

type CreditCardsState = CreditCard[];

const deleteCreditCardReducer: CaseReducer<
  CreditCardsState,
  PayloadAction<string>
> = (state, { payload: credit_card_id }) => {
  const removeIndex = state.findIndex(
    credits_card => credits_card.id === credit_card_id
  );

  state.splice(removeIndex, 1);
};

const initCreditCardsReducer: CaseReducer<
  CreditCardsState,
  PayloadAction<CreditCard[]>
> = (_state, { payload: credit_cards }) => {
  return credit_cards;
};

const CreditCards = createSlice({
  name: "CreditCards",
  initialState: [] as CreditCardsState,
  reducers: {
    initCreditCards: initCreditCardsReducer,
    deleteCreditCard: deleteCreditCardReducer
  }
});

export const { initCreditCards, deleteCreditCard } = CreditCards.actions;
export default CreditCards.reducer;
